export default class SsoApi {
  static set setToken(token) {
    this.token = token;
  }
  static set setBin(bin) {
    this.bin = bin;
  }
  static set setMsisdn(msisdn) {
    this.msisdn = msisdn;
  }
}
